import { AfterContentInit, AfterViewInit, Component, ElementRef, Input, OnChanges, OnInit } from "@angular/core";
import { ConstantsService } from "@app/services/constantsService";
import { NavigationService } from "@app/services/navigation.service";
import { BreadcrumbService, IBreadcrumb } from "@services/breadcrumb.service";
import { Transition } from "@uirouter/angularjs";
import { PageTitlePillComponent } from "../page-title-pill/page-title-pill.component";
import "./page-title.component.scss";

@Component({
    selector: "page-title",
    template: require("./page-title.component.html"),
})
export class PageTitleComponent implements OnInit, OnChanges, AfterViewInit, AfterContentInit {
    @Input() icon: string;

    @Input() useRoute: boolean;
    @Input("subtitle") originalSubtitle: string;
    
    // ---

    pills: PageTitlePillComponent[] = [];

    routeTitle: string;
    subtitle: string;
    hideSubtitle: boolean;

    showBackButton = false;
    parentState: IBreadcrumb;

    isMobile: boolean;

    constructor(
        private readonly el: ElementRef<HTMLElement>,
        private readonly navigationService: NavigationService,
        private readonly breadcrumbService: BreadcrumbService,
        private readonly transition: Transition,
        private readonly constantsService: ConstantsService
    ) {
        this.transition.onSuccess({}, () => this.updateRouteTitle());
        this.breadcrumbService.registerStateCallback(() => this.updateBreadcrumbs());
        this.isMobile = this.constantsService.getIsMobile();
    }

    ngOnChanges() {
        this.updateRouteTitle();
    }

    ngOnInit(): void {
        this.updateRouteTitle();
    }

    ngAfterViewInit() {
        this.updateRouteTitle();
    }

    ngAfterContentInit() {
        this.trimTitle();
    }

    onPillAdded(pill: PageTitlePillComponent) {
        this.pills.push(pill);

        this.onPillChanged();
    }

    onPillRemoved(pill: PageTitlePillComponent) {
        this.pills = this.pills.filter(p => p != pill);

        this.onPillChanged();
    }

    toggleMobileNavigation() {
        const nav = document.getElementsByTagName("module-navigation")[0];
        nav.classList.toggle("collapse-nav");
    }

    goToParent() {
        this.navigationService.goToParent();
    }

    // ---

    private updateRouteTitle() {
        this.subtitle = this.originalSubtitle;

        if (!this.useRoute) {
            return;
        }

        this.routeTitle = this.breadcrumbService.getPageTitle();        
        this.subtitle = this.breadcrumbService.getPageSubtitle() || this.originalSubtitle;

        this.updateBreadcrumbs();
    }

    private onPillChanged() {
        this.hideSubtitle = this.pills?.length > 0;
    }

    private updateBreadcrumbs() {
        this.showBackButton = false;
        const breadcrumbs = this.breadcrumbService.getBreadcrumbs();

        if (breadcrumbs.length <= 1) {
            return;
        }

        // If our parent state ISNT abstract, then show "Back to X"
        const currentBreadcrumb = breadcrumbs[breadcrumbs.length - 1];
        this.parentState = breadcrumbs[breadcrumbs.length - 2];

        if (currentBreadcrumb.state && !this.parentState.state.abstract && !this.parentState.state.data.preventBreadcrumbBack) {
            this.showBackButton = true;
        }
    }

    private trimTitle(recursionCount = 0) {
        let success = false;
        const titleElement = this.el.nativeElement.querySelector(".title");

        titleElement.childNodes.forEach((node) => {
            if (node.nodeType === Node.TEXT_NODE) {
                const text = node.textContent.trim();

                if (text) {
                    node.replaceWith(document.createTextNode(text));
                    success = true;
                }
            }
        });

        if (!success && recursionCount < 10) {
            setTimeout(() => { this.trimTitle(recursionCount + 1); }, 50);
        }
    }
}
